export function validateHealthgradesGroupUrl(raw) {
  if (!raw || !raw.trim()) return { ok: false, error: "URL is required." }

  let u
  try {
    u = new URL(raw)
  } catch {
    return { ok: false, error: "Invalid URL format (include https://)." }
  }

  if (u.protocol !== "https:")
    return { ok: false, error: "URL must use HTTPS (https://)." }

  const host = u.hostname.toLowerCase()
  if (host !== "www.healthgrades.com" && host !== "healthgrades.com") {
    return { ok: false, error: "URL must be on healthgrades.com." }
  }

  if (u.search) return { ok: false, error: "Query parameters are not allowed." }
  if (u.hash) return { ok: false, error: "Fragments (#...) are not allowed." }

  const path = u.pathname.replace(/\/+$/, "")
  const parts = path.split("/").filter(Boolean)

  if (parts[0] !== "group-directory") {
    return { ok: false, error: "URL must start with /group-directory/." }
  }

  // ✅ Accept EITHER:
  //   A) /group-directory/{STATE}/{state-name}/{city}/{group}-{id}  => total 5 parts
  //   B) /group-directory/{statecode}-{state-name}/{city}/{group}-{id} => total 4 parts
  if (parts.length !== 5 && parts.length !== 4) {
    return {
      ok: false,
      error:
        "Expected /group-directory/CA/california/{city}/{group}-{id} or /group-directory/ca-california/{city}/{group}-{id}.",
    }
  }

  let stateCode, stateName, city, groupSlugId

  if (parts.length === 5 && /^[A-Za-z]{2}$/.test(parts[1])) {
    // Pattern A
    stateCode = parts[1].toUpperCase()
    stateName = parts[2]
    city = parts[3]
    groupSlugId = parts[4]
  } else {
    // Pattern B (combined)
    const m = parts[1].match(/^([A-Za-z]{2})-([a-z]+(?:-[a-z]+)*)$/)
    if (!m)
      return {
        ok: false,
        error:
          "First segment must be STATE or STATE-stateName (e.g., CA or ca-california).",
      }
    stateCode = m[1].toUpperCase()
    stateName = m[2]
    city = parts[2]
    groupSlugId = parts[3]
  }

  const slugRe = /^[a-z]+(?:-[a-z]+)*$/
  if (!slugRe.test(stateName))
    return {
      ok: false,
      error: "State name must be a slug (letters and hyphens).",
    }
  if (!slugRe.test(city))
    return { ok: false, error: "City must be a slug (letters and hyphens)." }

  // group-name-{id}, where id can be alphanumeric
  const m2 = groupSlugId.match(/^([a-z0-9]+(?:-[a-z0-9]+)*)-([A-Za-z0-9]+)$/)
  if (!m2) {
    const lastDash = groupSlugId.lastIndexOf("-")
    if (lastDash === -1)
      return {
        ok: false,
        error:
          "Group segment must end with -{id} (e.g., indus-medical-associates-xb9tn2).",
      }
    const idPart = groupSlugId.slice(lastDash + 1)
    if (!/^[A-Za-z0-9]+$/.test(idPart))
      return { ok: false, error: "Group id must be alphanumeric." }
    return {
      ok: false,
      error: "Group name must be a slug (letters, numbers, hyphens).",
    }
  }

  const [, groupName, id] = m2

  return {
    ok: true,
    error: "",
    data: {
      state: stateCode,
      stateName: stateName.toLowerCase(),
      city: city.toLowerCase(),
      groupName: groupName.toLowerCase(),
      id,
      normalizedUrl: `https://www.healthgrades.com/group-directory/${stateCode}/${stateName.toLowerCase()}/${city.toLowerCase()}/${groupName.toLowerCase()}-${id}`,
    },
  }
}
